<section class="politica_vendas">
    <h1>Política de Vendas</h1>
    <p>Informamos que a Política de Vendas da TooBooK está em conformidade com as normas estabelecidas no Código de Defesa do Consumidor, Lei nº 8.078 de 11/09/1990. Valorizamos a proteção e os direitos dos nossos clientes, garantindo que suas compras sejam
        realizadas de acordo com as disposições legais e oferecendo um ambiente seguro e confiável para suas transações. Estamos comprometidos em proporcionar uma experiência de compra positiva e transparente, em total respeito ao Código de Defesa do
        Consumidor.
    </p>
</section>

<section class="forma_pagamento">
    <h1>Preços e formas de pagamentos</h1>

    <ul>
        <li>Os preços apresentados neste site são exclusivos para as escolas parceiras do Sistema Interativo de Ensino.</li>
        <li>Os preços podem ser diferentes dos praticados em outros canais de vendas, como livrarias, lojas físicas e outros e-commerce.</li>
        <li>Os preços têm validade somente no momento da compra e estão sujeitos a alterações sem aviso prévio.</li>
    </ul>

    <h3>Opções de pagamento:</h3>
    <ul>
        <li>Aceitamos boleto bancário (parcela única), e cartão de crédito (em até 10 parcelas).</li>
        <li>O pagamento com cartão de crédito está sujeito à aprovação da administradora do cartão do usuário.</li>
        <li>Parcelamento sem juros disponível de acordo com o estabelecido com a escola parceira.</li>
    </ul>

    <h3>Confirmação e liberação do pedido:</h3>
    <ul>
        <li>As compras serão liberadas após a confirmação do pagamento.</li>
        <li>Pedidos com pagamento não confirmado pela instituição financeira ficarão com status pendente e permanecerão no carrinho de compras.</li>
    </ul>

    <h3>Alterações de pedido:</h3>
    <ul>
        <li>Após a emissão do pedido de compra, não é possível alterar: produto, quantidade, forma de pagamento, quantidade de parcelas ou quaisquer outras informações.</li>
    </ul>
</section>

<section class="devolucao">
    <h1>Devolução e Troca</h1>

    <h3>Conferência dos produtos:</h3>
    <ul>
        <li>Verifique se estão em suas embalagens originais e devidamente lacradas.</li>
    </ul>

    <h3>Irregularidades:</h3>
    <ul>
        <li>Em caso de embalagem ou produto danificado, recuse o pedido e entre em contato com nosso atendimento.</li>
    </ul>

    <h3>Devolução por desistência ou insatisfação:</h3>
    <ul>
        <li>Entrar em contato em até sete dias após o recebimento do material, apresentando a nota fiscal da compra.</li>
    </ul>

    <h3>Troca por defeito:</h3>
    <ul>
        <li>O produto será avaliado internamente e, se aprovado, será trocado. Caso não haja disponibilidade em estoque do mesmo produto, será feito um ressarcimento de acordo com a nota fiscal apresentada.</li>
        <li>Produtos danificados por mau uso: Rasuras, dobras, umidade, etiquetas coladas e nomes escritos nos livros não serão passíveis de troca.</li>
    </ul>
</section>

<section class="cancelamento">
    <h1>Cancelamento de pedido</h1>

    <h3>Forma de pagamento: Boleto Bancário</h3>
    <ul>
        <li>Se o pagamento do boleto não for efetuado até o vencimento, o pedido será cancelado automaticamente, sem custos.</li>
        <li>Caso o pagamento do boleto já tenha sido realizado, o valor poderá ser restituído por meio de depósito bancário na conta corrente do titular da compra. A restituição será feita em até sete dias úteis após o envio do pedido de cancelamento para
            o formulário de contato (<a class="link-formulario" (click)="scrollToFormulario()">clique aqui</a>), contendo os dados bancários do responsável pela compra(nome completo, CPF, banco, agência, conta corrente ou chave pix).</li>
    </ul>

    <h3>Forma de pagamento: Cartão de Crédito</h3>
    <ul>
        <li>Para pedidos pagos com cartão de crédito, o valor será restituído por meio de um estorno realizado com a administradora do cartão do cliente, enviar a solicitação via formulário de contato (<a class="link-formulario" (click)="scrollToFormulario()">clique aqui</a>),
            contendo os dados do responsável pela compra (nome completo e CPF).</li>
        <li>Após a confirmação do cancelamento, o tempo para visualização do estorno dependerá exclusivamente das regras e prazos estabelecidos pela administradora do cartão.</li>
        <li>No caso de pagamentos parcelados, o valor será integralmente devolvido à administradora do cartão, e a restituição será feita pela própria administradora do cartão ao cliente.</li>
    </ul>

    <p>Se tiver dúvidas, entre em contato conosco!</p>
</section>

<section class="formulario" id="formulario">
    <div class="forma">
        <h1>Entre em contato conosco.</h1>
    </div>

    <form [formGroup]="formContato">
        <div class="input-error">
            <input type="text" placeholder="Nome" formControlName="nome">
            <p *ngIf="formContato.get('nome')?.invalid && (formContato.get('nome')?.dirty || formContato.get('nome')?.touched)">O campo é obrigatório.</p>
        </div>
        <div class="input-error">
            <input type="email" placeholder="E-mail" formControlName="email">
            <p *ngIf="formContato.get('email')?.invalid && (formContato.get('email')?.dirty || formContato.get('email')?.touched)">O campo é obrigatório.</p>
        </div>
        <div class="input-error">
            <input type="text" placeholder="WhatsApp" formControlName="whatsapp" mask="(00) 00000-0000">
            <p *ngIf="formContato.get('whatsapp')?.invalid && formContato.get('whatsapp')?.touched">O campo é obrigatório.</p>
        </div>
        <div class="input-error">
            <input type="text" placeholder="Nome da Escola" formControlName="escola">
            <p *ngIf="formContato.get('escola')?.invalid && (formContato.get('escola')?.dirty || formContato.get('escola')?.touched)">O campo é obrigatório.</p>
        </div>

        <textarea name="" id="" cols="30" rows="10" placeholder="Mensagem" formControlName="mensagem"></textarea>

        <div #divRecaptcha id="recaptcha"></div>
        <button (click)="enviaFormularioContato()">Enviar mensagem</button>
    </form>
</section>

<footer>
    <!-- <div class="endereço">
        <p class="footer_titulo">Endereço</p>
        <p class="footer_descricao">Endereço do local</p>
        <p class="footer_descricao">Rua com e numero</p>
        <p class="footer_descricao">Bairro</p>
        <p class="footer_descricao">Nome da cidade - SP</p>
        <p class="footer_descricao">CEP 18275-080</p>
    </div> -->
    <div class="cnpj">
        <p class="footer_titulo">Contato</p>
        <p class="footer_descricao">
            <a href="https://api.whatsapp.com/send/?phone=551532058892&text&app_absent=0" target="_blank" class="link-whatsapp">
                <svg xmlns="http://www.w3.org/2000/svg" height="22" width="20" viewBox="0 0 448 512">
                    <!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.-->
                    <path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6" style="fill: #2EC3E5;"/>
                </svg> WhatsApp: (15) 3205-8892

            </a>
        </p>
    </div>
    <div class="redes_sociais">
        <p class="footer_titulo">Nossas redes sociais</p>
        <div class="icones_redes_sociais">
            <a href="https://www.facebook.com/sistemainterativodeensino">
                <img src="../../../assets/home/icone-redes-sociais/facebook.svg" alt="Icone do Facebook">
            </a>
            <a href="https://www.instagram.com/sistemainterativodeensino/">
                <img src="../../../assets/home/icone-redes-sociais/instagram.svg" alt="Icone do Instragram">
            </a>
        </div>
    </div>
    <div class="endereço">
        <p class="footer_titulo">Informações</p>
        <p class="footer_descricao"><a href="/politica-vendas">Política de vendas</a></p>
        <p class="footer_descricao"><a href="/politica-privacidade">Política de privacidade</a></p>
    </div>
    <div class="endereco">
        <div class="bandeiras">
            <ul>
                <li><img alt="visa" title="visa" src="/assets/bandeira-cartao/visa.svg"></li>
                <li><img alt="mastercard" title="mastercard" src="/assets/bandeira-cartao/mastercard.svg"></li>
                <li><img alt="hipercard" title="hipercard" src="/assets/bandeira-cartao/hipercard.svg"></li>
                <li><img alt="elo" title="elo" src="/assets/bandeira-cartao/elo.svg"></li>
                <li><img alt="diners" title="diners" src="/assets/bandeira-cartao/diners.svg"></li>
                <li><img alt="cabal" title="cabal" src="/assets/bandeira-cartao/cabal.svg"></li>
                <li><img alt="amex" title="amex" src="/assets/bandeira-cartao/amex.svg"></li>
                <li><img alt="amex" title="amex" src="/assets/bandeira-cartao/boleto.svg"></li>
            </ul>
        </div>
        <img src="../../../assets/home/abcomm.png" alt="Icone do Abcomm" class="img-rodape-abcomm">
        <img src="../../../assets/home/siteSealImage.png" alt="Icone do SealImage" class="img-rodape-sealimage">
    </div>
</footer>

<span class="assinatura-rodape">&copy; Sistema Interativo de Ensino | CPB Educacional - {{year}}</span>

<button id="scroll-to-top-btn" (click)="scrollToTop()" *ngIf="showScrollButton">
          <mat-icon class="mat-18">arrow_upward</mat-icon>
    </button>